export function Loader({ text = 'Loading…' }: { text?: string }) {
  return (
    <div className="flex items-center justify-center min-h-[60vh] bg-transparent px-5">
      <div className="flex flex-col items-center gap-6">
        {/* Logo + Spinning Border */}
        <div className="relative  h-20 w-20 flex items-center justify-center">
          {/* Rotating Border */}
          <div className="absolute bg-transparent inset-0 rounded-full border-x-4 border-teal border-t-transparent animate-spin" />

          {/* Inner Soft Border (optional subtle look) */}
          <div className="absolute inset-2 rounded-full border " />

          {/* Logo */}
          <img
            src="/Black.svg"
            alt="Loading Logo"
            className="h-16 w-16 object-contain z-10"
          />
        </div>

        {/* Text */}
        <p className="text-sm lg:text-base text-text tracking-wide">{text}</p>
      </div>
    </div>
  );
}
